import { Icon } from './Icon';
import { AUDIENCES } from '../data';

export function WhoFor() {
  return (
    <section className="py-16 how-section">
      <div className="mx-auto w-full max-w-[1180px] px-7">
        <div className="reveal max-w-[560px] mb-14">
          <span className="lp-eyebrow"><Icon name="target" size={13} /> Who it's for</span>
          <h2 className="text-[clamp(28px,3.6vw,42px)] font-bold tracking-[-0.03em] leading-[1.1] mt-4">Built for stores that feel the pain fast</h2>
        </div>
        <div className="who-grid reveal reveal-stagger">
          {AUDIENCES.map((a) => (
            <div className="who-card" key={a.title}>
              <div className="who-ico"><Icon name={a.icon} size={19} /></div>
              <div>
                <h4>{a.title}</h4>
                <p>{a.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
